import InlinePrivacy from './InlinePrivacy';

export default InlinePrivacy;
